import RestRepository from "../../infra/RestRepository";

export default class CommunityRestRepo extends RestRepository {
  constructor() {
    super("/api/communities");
  }
}
